import { render } from "./OrderConfirm.vue?vue&type=template&id=33201efb&scoped=true"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"

import "./OrderConfirm.vue?vue&type=style&index=0&id=33201efb&scoped=true&lang=css"

import exportComponent from "/data/fe-node-modules/beta-ab/candao-h5-v6-phd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33201efb"]])

export default __exports__